<template>
    <v-menu offset="10" transition="slide-y-transition">
        <template v-slot:activator="{ props }">
            <v-btn v-bind="props" icon class="mx-2">
                <v-avatar size="30">
                    <v-img v-if="user.avatar" :src="user.avatar" :alt="user.name" />
                    <v-icon v-else size="30">$accountCircle</v-icon>
                </v-avatar>
            </v-btn>
        </template>
        <v-card elevation="5" min-width="300">
            <v-list>
                <v-list-item :to="{ name: 'myaccount' }" :active="false">
                    <template v-slot:prepend>
                        <v-avatar>
                            <v-img v-if="user.avatar" :src="user.avatar" :alt="user.name" />
                            <v-icon v-else size="40">$accountCircle</v-icon>
                        </v-avatar>
                    </template>

                    <v-list-item-title>{{ user.name }}</v-list-item-title>
                    <v-list-item-subtitle>
                        {{ user.email }}
                    </v-list-item-subtitle>
                </v-list-item>
            </v-list>

            <v-divider />

            <v-list density="compact" class="mx-3 text-body-medium user-dropdown-list">
                <v-list-item :to="{ name: 'myaccount' }" :active="false">
                    <template v-slot:prepend>
                        <v-icon size="small">$person</v-icon>
                    </template>
                    <v-list-item-title class="ml-1 text-body-medium">My Account</v-list-item-title>
                </v-list-item>

                <v-list-item @click="signOut">
                    <template v-slot:prepend>
                        <v-icon size="small">$directionsWalk</v-icon>
                    </template>
                    <v-list-item-title class="ml-1 text-body-medium">Sign Out</v-list-item-title>
                </v-list-item>

                <v-divider class="ma-2" />

                <v-list-item href="https://www.fluxoutdoor.com" target="_blank">
                    <template v-slot:prepend>
                        <div class="v-icon v-icon--size-small"
                            style="display: inline-flex; align-items: center; justify-content: center;">
                            <svg width="16" height="16" viewBox="0 0 98 140" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M22 21V61H82V82H22V140H0V104C0 91.8497 9.84974 82 22 82V61H0V0H98V21H22Z"
                                    :fill="$vuetify.theme.current.dark ? 'white' : 'black'" />
                            </svg>
                        </div>
                    </template>
                    <v-list-item-title class="ml-1 text-body-medium">Flux Website</v-list-item-title>
                </v-list-item>

                <v-divider class="ma-2" />

                <v-list-item @click="changeTheme">
                    <template v-slot:prepend>
                        <v-icon size="small">$darkMode</v-icon>
                    </template>
                    <v-list-item-title class="ml-1 text-body-medium">Dark Theme</v-list-item-title>
                    <template v-slot:append>
                        <v-switch v-model="isLightTheme" color="blue" hide-details density="compact" readonly />
                    </template>
                </v-list-item>
            </v-list>
        </v-card>
    </v-menu>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useUserStore } from "@/stores/user";

export default {
    data() {
        return {
            isLightTheme: true,
        };
    },
    computed: {
        ...mapState(useUserStore, ["user"]),
    },
    methods: {
        ...mapActions(useUserStore, ["logout"]),
        changeTheme() {
            const newTheme = this.$vuetify.theme.global.current.dark ? 'light' : 'dark';
            this.$vuetify.theme.change(newTheme);
            localStorage.setItem("darkTheme", newTheme === 'dark');
        },
        signOut() {
            this.logout()
                .catch(() => {
                    // I want logout to not crash
                })
                .finally(() => {
                    window.location.href = "/";
                });
        },
    },
    created() {
        this.isLightTheme = this.$vuetify.theme.global.current.dark;
    },
};
</script>

<style scoped>
.user-dropdown-list :deep(.v-list-item__prepend) {
    width: 40px;
    justify-content: center;
}
</style>
